// extracted by mini-css-extract-plugin
module.exports = {"authorWrapper":"Description--authorWrapper--1LJC6","title":"Description--title--1TNaF","count":"Description--count--3NGLy"};